import { useCallback } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useUrlSearchParams } from 'core/Hooks';
import { useNavigate } from 'react-router-dom';
import { useShowPostCheckoutCart } from 'store/Api';
import { ButtonMantine } from 'ui';

import { useNavigateToAuth } from '../../../hooks/useNavigateToAuth/useNavigateToAuth';
import { PostCheckoutRedirectPageTemplate } from '../PostCheckoutRedirectPageTemplate/PostCheckoutRedirectPageTemplate';
import { MembershipCardWithDetails } from './MembershipRedirectPage';

const MembershipRedirectFinalPage = () => {
  const navigate = useNavigate();
  const { handleNavigateToAuth } = useNavigateToAuth();
  const { isAuthenticated } = useAuthentication();

  const { cartId, email, firstName, lastName } = useUrlSearchParams([
    'cartId',
    'email',
    'firstName',
    'lastName',
  ]);
  const { data } = useShowPostCheckoutCart({
    cartId,
    email,
  });

  const causeName = data?.cart.cause.name ?? 'your cause';
  const accountRoute = '/account';

  const onPrimaryCtaClick = useCallback(() => {
    if (isAuthenticated) {
      navigate(accountRoute);
      return;
    }

    handleNavigateToAuth({
      page: 'sign-up',
      redirect: accountRoute,
      additionalParams: {
        firstName,
        lastName,
        email,
      },
    });
  }, [isAuthenticated, handleNavigateToAuth, firstName, lastName, email, navigate, accountRoute]);

  return (
    <PostCheckoutRedirectPageTemplate
      title="Access your membership with the Givebacks app"
      leftSection={
        <PostCheckoutRedirectPageTemplate.AppBenefits>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            Access your membership any time
          </PostCheckoutRedirectPageTemplate.AppBenefit>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            Manage donations and purchases for all your organizations
          </PostCheckoutRedirectPageTemplate.AppBenefit>
          <PostCheckoutRedirectPageTemplate.AppBenefit>
            {`View 15,000 online merchants and 10,000 local restaurants supporting ${causeName}`}
          </PostCheckoutRedirectPageTemplate.AppBenefit>
        </PostCheckoutRedirectPageTemplate.AppBenefits>
      }
      rightSection={<MembershipCardWithDetails />}
      cta={<ButtonMantine onClick={onPrimaryCtaClick}>View Membership Card</ButtonMantine>}
    />
  );
};

export { MembershipRedirectFinalPage };
